import { OrderData } from '../../../api';
import { isPendingOrder } from '../../../common/pendingOrderUtils';

export type CloseDaySummary = {
  open: OrderData[];
  closedWithNote: OrderData[];
  closedCount: number;
  totalCount: number;
};

export const closeDaySummary = (orders: OrderData[], referenceSeconds: number): CloseDaySummary => {
  const eligible = orders.filter(
    (order) =>
      !isPendingOrder(order) &&
      order.checkin &&
      order.extra_items?.length &&
      referenceSeconds >= (order.time ?? 0) + order.duration,
  );
  const open = eligible
    .filter((order) => (order.balance_due ?? 0) > 0 && !order.balance_closed_at)
    .sort((first, second) => (first.time ?? 0) - (second.time ?? 0));
  return {
    open,
    closedWithNote: eligible.filter((order) => order.balance_closed_at),
    closedCount: eligible.length - open.length,
    totalCount: eligible.length,
  };
};
